import React from 'react';
import { Tooltip } from 'antd';
import { subjectChipStyle } from './subjectColors';

/**
 * چیپ رنگی موضوع تماس.
 *
 * @param {{name: string, color: string, description?: string}} subject
 * @param {'small'|'default'} size
 */
const CallSubjectChip = ({ subject, size = 'default', className = '', onClick }) => {
  if (!subject?.name) return null;

  const chip = (
    <span
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      className={`custom-font inline-flex items-center gap-1.5 rounded-full border font-medium whitespace-nowrap max-w-full ${
        size === 'small' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'
      } ${onClick ? 'cursor-pointer hover:brightness-95 transition' : ''} ${className}`}
      style={subjectChipStyle(subject.color)}
    >
      <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: subject.color }} />
      <span className="truncate">{subject.name}</span>
    </span>
  );

  return subject.description ? <Tooltip title={subject.description}>{chip}</Tooltip> : chip;
};

export default CallSubjectChip;
